module.exports = __webpack_public_path__ + "static/media/selected.9596573d.svg";